import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

const HeaderSignOutButton = ({ className }) => {
  const { t } = useTranslation();
  const { logout } = useAuth();

  return (
    <button
      type="button"
      onClick={logout}
      className={
        className ||
        'rounded-lg px-3 py-1.5 text-sm text-zinc-600 transition hover:bg-zinc-100 hover:text-zinc-900 dark:text-zinc-400 dark:hover:bg-zinc-800 dark:hover:text-zinc-100'
      }
    >
      {t('common.signOut')}
    </button>
  );
};

export default HeaderSignOutButton;
